<button
  *ngIf="isAdmin()"
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addItinerary()"
>
  <mat-icon>add</mat-icon>
</button>

<div
  *ngIf="
    itinerariesPendingCurrentUserAssignmentProposals &&
    itinerariesPendingCurrentUserAssignmentProposals.length > 0
  "
>
  <mat-card class="card card-proposals mat-elevation-z8">
    <mat-nav-list style="padding-top: 0">
      <div
        *ngFor="
          let proposal of itinerariesPendingCurrentUserAssignmentProposals;
          let last = last
        "
      >
        <app-assignment-proposal-list-item
          [proposal]="proposal"
          (answered)="
            itinerariesPendingCurrentUserAssignmentProposals.splice(
              itinerariesPendingCurrentUserAssignmentProposals.indexOf(
                proposal
              ),
              1
            )
          "
        ></app-assignment-proposal-list-item>
        <mat-divider *ngIf="!last"></mat-divider>
      </div>
    </mat-nav-list>
  </mat-card>
</div>

<div class="container">
  <nav mat-tab-nav-bar class="mat-tab-nav-bar-blue">
    <a
      mat-tab-link
      (click)="archived = false; list()"
      [active]="archived === false"
      ><mat-icon aria-hidden="false" aria-label="">inbox</mat-icon
      >&nbsp;&nbsp;&nbsp;In Arrivo</a
    >
    <a
      mat-tab-link
      (click)="archived = true; list()"
      [active]="archived === true"
      ><mat-icon aria-hidden="false" aria-label="">view_list</mat-icon
      >&nbsp;&nbsp;&nbsp;Archiviati</a
    >
  </nav>
</div>

<div class="container">
  <div
    *ngIf="itineraries$ | async | itinerarySortByStatus as itineraries"
    class="wrapper"
  >
    <mat-card class="card mat-elevation-z8">
      <mat-nav-list style="padding-top: 0">
        <div *ngFor="let itinerary of itineraries; let last = last">
          <app-itinerary-list-item
            [itinerary]="itinerary"
            [userRole]="isAdmin() ? 'ADMIN' : 'TRAVEL_ADVISOR'"
            (archiveClicked)="archive(itinerary)"
            (unarchiveClicked)="unarchive(itinerary)"
            (deleteClicked)="delete(itinerary)"
          ></app-itinerary-list-item>
          <mat-divider *ngIf="!last"></mat-divider>
        </div>
      </mat-nav-list>

      <div
        style="text-align: center; margin: 25px 0"
        *ngIf="itineraries.length === 0"
      >
        Nessun itinerario
      </div>
    </mat-card>
  </div>
</div>
